<script>
  import { apiFetch } from "../../lib/api.js";
    import { user } from "../../stores/user";
    import CardContent from "../CardContent.svelte";
    import { BASE_URL } from "../../stores/BASE_URL";
    import getFecha from "../../services/fecha";
    import Spinner from "../Spinner.svelte";

    export let id = 0;

    let isLoading = false;
    let fecha = getFecha();
    let sesiones = [];

    const getSesiones = async () => {
        isLoading = true;
        const response = await apiFetch(`${BASE_URL}usuario.php?action=getSesiones&id=${id}&fecha=${fecha}`);
        const resp = await response.json();
        sesiones = resp.data;
        isLoading = false;
    };

    getSesiones();
</script>

<CardContent title={`Inicios de Sesión`}>
    <div class="row">
        <div class="col-12 col-md-6 col-lg-3">
            <input type="date" class="form-control" bind:value={fecha} on:change={getSesiones} />
        </div>
    </div>

    <div class="table-responsive mt-3">
        <table class="table table-sm table-striped table-bordered">
            <thead>
                <tr class="text-secondary fw-normal">
                    <th>Cliente</th>
                    <th>Usuario</th>
                    <th>Nombres</th>
                    <th>IP</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                </tr>
            </thead>
            <tbody>
                {#if isLoading}
                    <tr>
                        <td colspan="6">
                            <Spinner message="Cargando" />
                        </td>
                    </tr>
                {:else}
                    {#each sesiones as sesion}
                        <tr>
                            <td>{sesion.razon_social}</td>
                            <td>{sesion.usuario}</td>
                            <td>{sesion.nombres}</td>
                            <td>{sesion.ip}</td>
                            <td>
                                {#if sesion.estado == "1"}
                                    <small
                                        class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                                    >
                                        Exitoso
                                    </small>
                                {:else if sesion.estado == "0"}
                                    <small
                                        class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                                    >
                                        Error
                                    </small>
                                {/if}
                            </td>
                            <td>{sesion.fecha}</td>
                        </tr>
                    {:else}
                        <tr>
                            <td colspan="6" class="text-center text-secondary"> · · · No se encontraron resultados · · · </td>
                        </tr>
                    {/each}
                {/if}
            </tbody>
        </table>
    </div>
</CardContent>
